import { render, staticRenderFns } from "./OuterPacketBuy.vue?vue&type=template&id=52e1e556&scoped=true&"
import script from "./OuterPacketBuy.vue?vue&type=script&lang=js&"
export * from "./OuterPacketBuy.vue?vue&type=script&lang=js&"
import style0 from "./OuterPacketBuy.vue?vue&type=style&index=0&id=52e1e556&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e1e556",
  null
  
)

export default component.exports